import { FC, ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';

import { formatPriceFromCents } from '@mopla/utils';

import { useBookingRide } from '../BookingRideContext';

import { getChargedCancellationFeeCents } from './model';
import { FeeRow } from './styled';

type TRender = (parts: {
	label: string;
	price: string;
	dataTestId?: string;
}) => ReactElement;

export interface ICancellationChargedFeeProps {
	render?: TRender;
	dataTestId?: string;
}

const renderFeeRow: TRender = ({ label, price, dataTestId }) => (
	<FeeRow>
		<Typography variant="h4-sb">{label}</Typography>
		<Typography variant="h4-sb" data-testid={dataTestId}>
			{price}
		</Typography>
	</FeeRow>
);

/**
 * What the cancellation cost the passenger; nothing until the ride is cancelled.
 * A free cancellation still states its 0,00 €.
 */
export const CancellationChargedFee: FC<ICancellationChargedFeeProps> = ({
	render = renderFeeRow,
	dataTestId,
}) => {
	const { t } = useTranslation('booking');
	const { booking, rideCanceller } = useBookingRide();

	if (!rideCanceller) {
		return null;
	}

	return render({
		label: t('booked.detail.footer.cancellation_fee'),
		price: formatPriceFromCents(getChargedCancellationFeeCents(booking)),
		dataTestId,
	});
};
